import { IMonitorSalesProductItem } from 'entities/MonitorSales/MonitorSales.models';

export const formatValue = (label: string, value: number, maximumFractionDigits?: number): string => {
  if (label === 'TC') {
    return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  return `₱ ${value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

export const sortProductSalesBySalesPercentDesc = (products: IMonitorSalesProductItem[]): IMonitorSalesProductItem[] =>
  [...products].sort((a, b) => b.salesPercent - a.salesPercent);
